import React, { useState, useEffect, useCallback } from 'react'
import Card from 'react-bootstrap/Card';
import Controllers from '../../Api/Controllers';
import Helpers from '../../Components/Helpers/Helpers';
import { toast } from 'react-toastify'
import { FormCustom, Input, Select } from '../../Components/Form/Form';
import Button from 'react-bootstrap/Button'
import Loading from '../../Components/Layout/Styled/Loading'
import ReactPlaceholder from 'react-placeholder/lib';

const ReporteFacturamaFolio = () => {
    const [reporte, setReport] = useState({})
    const [ready, setReady] = useState(false)

    const [showLoading, setShowLoading] = useState(false)

    const [branchOffices, setBranchOffices] = useState([])
    const [data, setData] = useState({
        p_date_start: '',
        p_date_end: '',
        p_id_period: '',
        p_id_branch_office: ''
    })

    useEffect(() => {
        Controllers.worker.get_worker_branch_office_public().then(res => {
            setBranchOffices([
                ...res.data
            ])
        }).then(_ => {
            setReady(true)
        })
    }, [])

    const branchOffice = useCallback(() => {
        if (!data.p_id_branch_office) {
            return ''
        }

        let findBranchOffice = branchOffices.find(w => parseInt(w.id_branch_office) === parseInt(data.p_id_branch_office))

        if (!findBranchOffice) {
            return ''
        }

        return {
            label: findBranchOffice.name_branch_office,
            value: findBranchOffice.id_branch_office
        }
    }, [data.p_id_branch_office, branchOffices])

    return <>
        <ReactPlaceholder rows={10} showLoadingAnimation ready={ready}>
            <Card>
                <Card.Header className="justify-content-between">
                    <span>Reporte Facturama Folio</span>
                </Card.Header>
                <Card.Body>
                    <FormCustom viewSubmit={false} onSubmit={_ => {
                        if (isNaN(parseInt(data.p_id_branch_office))) {
                            Helpers.toast.construct({
                                response: 'warning',
                                message: 'Debe seleccionar una sucursal',
                                toast
                            })
                            return
                        }
                        setShowLoading(true)
                        setReport({})

                        Controllers.facturama.report_folio_facturama(data).then(res => {
                            if (res.response !== 'success') {
                                Helpers.toast.construct({ ...res, toast })
                                return
                            }
                            setReport({
                                excel: res.data.excel.file,
                                filename: res.data.excel.filename,
                            })
                        }).catch(req => Helpers.promise.catch({ req, toast }))
                            .finally(() => {
                                setShowLoading(false)
                            })
                    }}>
                        <Select
                            classNameParent="col-12 mb-2"
                            icon="fa fa-building"
                            text="Sucursal"
                            required
                            onChange={e => {
                                setReport({})
                                setData({ ...data, p_id_branch_office: e.value })
                            }}
                            value={branchOffice()}
                            options={branchOffices.map(w => {
                                return {
                                    label: w.name_branch_office,
                                    value: w.id_branch_office
                                }
                            })}
                        />
                        <Input
                            classNameParent="col-6 col-md-4 mb-2"
                            icon="far fa-calendar"
                            placeholder="Fecha Inicio"
                            text="Fecha Inicio"
                            onChange={e => setData({ ...data, p_date_start: e.currentTarget.value })}
                            required
                            type="date"
                            value={data.p_date_start}
                        />
                        <Input
                            classNameParent="col-6 col-md-4 mb-2"
                            icon="far fa-calendar"
                            placeholder="Fecha Fina"
                            text="Fecha Fina"
                            onChange={e => setData({ ...data, p_date_end: e.currentTarget.value })}
                            required
                            type="date"
                            value={data.p_date_end}
                        />
                        <div className="col-12 mb-2">
                            <Button type="submit" size="sm">
                                <i className="fa fa-search"></i> Generar Reporte
                            </Button>
                        </div>
                    </FormCustom>
                    {reporte?.filename ? <div className='mb-4'>
                        <a href={reporte?.excel} download={reporte?.filename} className="mr-2">
                            <Button size="sm" variant="success">
                                <i className="fa fa-file-excel mr-2"></i>Descargar Reporte Excel
                            </Button>
                        </a>
                    </div> : ''}
                </Card.Body>
            </Card>
            <Loading show={showLoading}>
                <Loading.Img src={Helpers.config.resourcesUrl({ url: '/images/dashboard/preloading.svg' })} alt="Preloading" />
            </Loading>
        </ReactPlaceholder>
    </>
}

export default ReporteFacturamaFolio